import { readProfile } from '../requests/loader';
import ProfileReadCache from '../AAF/LoaderExp/ProfileReadCache';

export const initialState = {  
  isFetching: false,
  members: []
};

export const SET_PROFILE = "SET_PROFILE";
export const REQUEST_PROFILE_READ = "REQUEST_PROFILE_READ";
export const RECEIVE_PROFILE_READ = "RECEIVE_PROFILE_READ";
export const RECEIVE_MEMBERS = "RECEIVE_MEMBERS";

export const requestProfileRead = () => ({ type: REQUEST_PROFILE_READ });
export const receiveProfileRead = (members) => ({ type: RECEIVE_PROFILE_READ, members });


const thenFunction = (result, params, cb = null, cbError = null, dispatch) => {
  let members;
  if(ProfileReadCache.loadReadProfileInit()){
    ProfileReadCache.setFirstTimeToLoad(true);
    members = result.data && result.data.members ? result.data.members : result && result.members ? result.members : [];
  }else{
    ProfileReadCache.setFirstTimeToLoad(false);
    result =  JSON.parse(result).resp;
    members = result.data && result.data.members ? result.data.members : result && result.members ? result.members : [];
  }
  if (result.completeError) {
    if (typeof cbError === 'function') {
      console.log('[fetchProfileRead] ejecuta cbError');
      cbError(result.completeError);
    }
  } else
  if (typeof cb === 'function') {
    console.log('[fetchProfileRead] ejecuta cb');
    if(ProfileReadCache.loadReadProfileInit()){
      ProfileReadCache.setReadProfileStorage(result);
    }
    const response = result && result.data ? result.data : result && result.members ? result : {};
    cb(response);
  }
  dispatch(receiveProfileRead(members));
}



export const fetchProfileRead = (params, cb = null, cbError = null) => dispatch => {
  dispatch(requestProfileRead());
  if(ProfileReadCache.loadReadProfileInit()){
    // SI NO EXISTE CACHE EN EL STORAGE, SE HACE LLAMADA DESDE INICIO
    return readProfile(params)
    .then(result => thenFunction(result,params,cb, cbError, dispatch))
    .catch(err => {
      dispatch(receiveProfileRead(initialState));
    });
  }else{
    return ProfileReadCache.getReadProfileFromStorage()
    .then(result => thenFunction(result,params,cb, cbError, dispatch))
    .catch(err => {
      dispatch(receiveProfileRead(initialState));
    });
  }
};






// WEBPACK FOOTER //
// ./src/actions/profile.js